export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 64;
export const PASSWORD_VALIDATION_MESSAGE = `密码长度需为${PASSWORD_MIN_LENGTH}至${PASSWORD_MAX_LENGTH}个字符，且不能包含空白字符`;

const PASSWORD_PATTERN = new RegExp(`^\\S{${PASSWORD_MIN_LENGTH},${PASSWORD_MAX_LENGTH}}$`);

export const isValidPassword = (value) => {
    return typeof value === "string" && PASSWORD_PATTERN.test(value);
};
